"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.focusStyles = void 0;
var _styledComponents = require("styled-components");
const focusStyles = exports.focusStyles = (0, _styledComponents.css)([":focus{outline-width:2px;outline-style:solid;outline-color:Highlight;}@media (-webkit-min-device-pixel-ratio:0){:focus{outline-color:-webkit-focus-ring-color;outline-style:auto;}}"]);